<div [class]="'suite-info ' + (additionalClass ? additionalClass : '')">
  <div class="suite-info__title flex flex-wrap items-center gap-x-4 gap-y-2">
    <h3 class="aka-h5 h5--secondary suite-info__title-text">{{ name }}</h3>
    <div class="guest-capacity__container" data-testid="qa-guest-capacity">
      <app-guest-capacity *ngIf="showMaxGuestsIcon" [maxGuests]="maxGuests" />
    </div>
  </div>
</div>
